export const FORM_IDENTIFIER = 'app/VolunteerFormPage';

export const INIT = 'app/VolunteerFormPage/INIT';
export const INIT_SUCCESS = 'app/VolunteerFormPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/VolunteerFormPage/INIT_FAILED';
export const SAVE = 'app/VolunteerFormPage/SAVE';
export const SAVE_SUCCESS = 'app/VolunteerFormPage/SAVE_SUCCESS';
export const SAVE_FAILED = 'app/VolunteerFormPage/SAVE_FAILED';
